import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { EventInformationComponent } from './event-information.component'
import { DesktopComponent } from './desktop/desktop.component'
import { MobileComponent } from './mobile/mobile.component'
import { DateFormatService, LocalDeviceDetectorService } from 'dmmp-services'
import { SharedModule } from '../shared/shared.module'


@NgModule({
  imports: [
    CommonModule,
    NgbNavModule,
    SharedModule
  ],
  declarations: [EventInformationComponent, DesktopComponent, MobileComponent],
  exports: [
    EventInformationComponent
  ],
  providers: [
    DateFormatService,
    LocalDeviceDetectorService
  ]
})
export class EventInformationModule { }
